import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

function AuthBootstrapper({ children }: { children: React.ReactNode }) {
  const setAuthLoaded = useAuthStore((s) => s.auth.setAuthLoaded)
  const accessToken = useAuthStore((s) => s.auth.accessToken)

  useEffect(() => {
    // If we have an access token, we assume we are loaded for now.
    // The Axios interceptors will handle 401s if the token is invalid.
    if (accessToken) {
      setAuthLoaded(true)
    } else {
      setAuthLoaded(false)
    }
  }, [accessToken, setAuthLoaded])

  return <>{children}</>
}

export default AuthBootstrapper; 